import { FC, useEffect } from 'react'

import { useAppDispatch } from 'hooks/store'
import { setTitle } from 'reducers/activecourse/activecourseSlice'

import {
  ContentNotAvailableContainer,
  ContentNotAvailableIcon,
  ContentNotAvailableIconContainer,
  ContentNotAvailableText
} from './styles'

interface ContentNotAvailabeProps {
  iconClass?: string
  title?: string
  datatestid: string
}

const ContentNotAvailable: FC<ContentNotAvailabeProps> = ({
  children,
  iconClass = 'mdi-certificate',
  title = null,
  datatestid = 'content-not-available'
}) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (title) {
      dispatch(setTitle(title))
    }
  }, [])

  return (
    <ContentNotAvailableContainer data-testid={`${datatestid}-container`}>
      <ContentNotAvailableIconContainer>
        <ContentNotAvailableIcon
          className={`mdi ${iconClass}`}
          data-testid={`${datatestid}-icon`}
        />
      </ContentNotAvailableIconContainer>
      <ContentNotAvailableText data-testid={`${datatestid}-text`}>
        {children}
      </ContentNotAvailableText>
    </ContentNotAvailableContainer>
  )
}

export default ContentNotAvailable
